import { __isProxy } from '../value';
import { buildOpts } from './utils';
export class Mixin {
    constructor(...args) {
        this._raw = [];
        for (let i = 0; i < args.length; i++) {
            this.mix(args[i]); //FIXME  потенциальная потеря производительности
        }
    }
    mixins() {
        return this._raw;
    }
    mix(nextOpts) {
        if (nextOpts != null) {
            if (typeof nextOpts.mixins === 'function') {
                //                console.log(nextOpts.mixins())
                this._raw = this._raw.concat(nextOpts.mixins()); //(nextOpts as any)._raw)
            }
            else {
                this._raw.push(nextOpts);
            }
        }
        return this;
    }
    mergeBefore(prevOpts) {
        if (prevOpts != null) {
            if (prevOpts.mix !== undefined) {
                debugger;
                this._raw = prevOpts._raw.concat(this._raw);
            }
            else {
                this._raw.unshift(prevOpts);
            }
        }
        return this;
    }
    build(rules) {
        if (this._raw.length == 0) {
            return undefined;
        }
        // немножко эвристики для кейсов, когда опции отключаются последним сегментом
        if (this._raw[this._raw.length - 1] === false) {
            return false;
        }
        if (this._raw[0] === true && this._raw.length == 1) {
            return true;
        }
        let o = {};
        let clear = false;
        for (let i = 0; i < this._raw.length; i++) {
            if (this._raw[i] === true) {
                clear = false;
                //        continue
            }
            else if (this._raw[i] === false) {
                clear = true;
                //        continue
            }
            else {
                if (clear) {
                    o = {};
                }
                o = buildOpts(o, this._raw[i], rules);
                clear = false;
            }
        }
        return clear ? {} : o;
    }
    get entries() {
        return this._raw;
    }
}
export const lastEffectiveValue = (o) => {
    let last = undefined;
    for (let value of o.entries) {
        if (value === true || value === false) {
            last = (last === !value || last == null) ? value : last;
        }
        else if (value != null) {
            last = value;
        }
    }
    return last;
};
export const mixin = (...args) => {
    return new (Function.prototype.bind.apply(Mixin, [null, ...args]));
};
export const isMixed = (obj) => {
    if (obj) {
        if (false && obj[__isProxy]) {
            return ('mix' in obj);
        }
        else {
            return typeof obj.mix === 'function';
        }
    }
    return false;
    //    return !!(obj && (obj as Mixed<T>).mix)
};
